import { Component, Input } from "@angular/core";
import { Router } from "@angular/router";

/*##################################################################################*
 * COMPOSANT SPRO : spro-chemin
 *
 * DESCRIPTION : Permet d'afficher un historique des pages en donnant les pages en parametres
 *
 ##################################################################################*/

@Component({
  selector: "spro-chemin",
  styleUrls: ["./spro-chemin.component.scss"],
  template: `
    <ul id="breadcrumb" *ngIf="h_navigation">
      <li>
        <a (click)="proc_naviguer(w_accueil)"> <i class="fa fa-home"></i> </a>
      </li>
      <li *ngFor="let nav of h_navigation">
        <a (click)="proc_naviguer(nav.w_path, nav.h_param)">
          {{ nav.w_label | translate }}
        </a>
      </li>
    </ul>
  `
})
export class spro_cls_chemin {
  /** Chemin (path) pour l'accès à la page d'acceuil*/
  @Input() w_accueil: string = "pages/commun/pageAccueil";
  /** les attributs de l'entrée sont w_label pour le label a afficher et w_path pour le routing*/
  @Input() h_navigation: Array<{
    w_label: string;
    w_path: string;
    h_param?: any;
  }>;

  constructor(public router: Router) {}

  /**
   * Accès à la page, ou nous envoi ce chemin
   */
  public proc_naviguer(path: string, h_param: any) {
    if (h_param == null) this.router.navigate([path]);
    else this.router.navigate([path], { queryParams: h_param });
  }
}



// WEBPACK FOOTER //
// C:/spro/Workspaces/VisualCode/Ecoltex2/src/app/sproLib/spro/utils/spro-chemin/spro-chemin.component.ts